import trackingDefaultDataTypesHydrator from './trackingDefaultDataTypes';

const trackingVisitHydrator = async (options) => {
    const trackingSearchData = {};
    const trackingDefaultDataTypes = await trackingDefaultDataTypesHydrator(options);

    _.extend(trackingSearchData, {
        page: window.location.pathname,
        query: window.location.hash,
        referrer: document.referrer,
    }, trackingDefaultDataTypes);

    return trackingSearchData;
};

export default trackingVisitHydrator;